module.exports = __webpack_public_path__ + "static/media/blog-administracion-sistemas-programacion-6000.c14b2111.jpg";